<div class="container">
  <div class="card" *ngIf="displayLogin">
    <div class="title-container">
      <div class="logo">
        <img width="205px" [src]="'../../../../../assets/Hayrick/logo/'+subdomain+'/logo-light.svg'" alt="Hayrick logo" />
      </div>
      <h1 class="title-1">WELCOME BACK</h1>
      <h1 class="title-2">Sign In!</h1>
    </div>

    <div class="input-box">
      <form [formGroup]="signinForm">
        <div class="input-container">
          <input type="tel"
          id="mobileSignin"
          name="phone" onkeyup="this.value = this.value.replace(/[^0-9-]/g, '');"
          placeholder="Mobile number"
          formControlName="phone"
          appIntlTelInput class="custom" />
          <div class="p-field">

              <input
                maxlength="4"
                formControlName="passcode"
                id="passcode"
                class="passcode"
                type="password"
                placeholder="Passcode"
                (keyup.enter)="signIn()"
              />


          </div>
        </div>
      </form>

      <div style="height: 20px">
        <div *ngIf="!phone.invalid">
          <a href="javascript:void(0);" class="forgot-btn" (click)="onForgotPasscodeLinkClick()"
            >Forgot passcode?</a
          >
        </div>
      </div>
    </div>

    <div class="signinbutton">
      <dx-button type="default" mode="contained" [disabled]="signinForm.invalid" (click)="signIn()" class="sign-in-button">Sign In!</dx-button>
    </div>

    <div class="existing-member-container">
      <p *ngIf="tnc" class="terms">
        By continuing you accept our
        <span *ngFor="let t of tnc; let i = index">
          <a href="{{ t.filePath }}" target="_blank">{{ t.signInDisplayName }}</a>
          <span *ngIf="i < tnc.length - 1">, </span>
          <span *ngIf="i === 0 || i === tnc.length - 1">.</span>
        </span>
      </p>
    </div>
  </div>

  <div class="card" *ngIf="displayFPMobileSubmit">
    <div class="logo-backBtn-container">
      <div class="back-btn-container">
        <div (click)="navSubmitMobileBackBtn()" class="back-button">
          <img class="back-arrow-icon" src="../../../../assets//back-arrow.svg" alt="navigate back" />
        </div>
      </div>
    </div>
    <div class="title-container">

      <h1 class="title-2">Forgot Passcode</h1>
    </div>


    <div class="text-container">
      <p class="text-1">Enter your mobile number and click submit.</p>

    </div>

    <div class="input-box">
      <form [formGroup]="fpSubmitMobileForm">
        <div class="input-container">
          <input type="tel"
          id="mobileSignin"
          name="phone" onkeyup="this.value = this.value.replace(/[^0-9-]/g, '');"
          placeholder="Mobile number"
          formControlName="phone"
          appIntlTelInput class="custom" />

        </div>
      </form>
    </div>

    <div class="signinbutton">
      <dx-button type="default" mode="contained" [disabled]="fpSubmitMobileForm.invalid" (click)="onSubmitMobileClick()" class="sign-in-button">Submit</dx-button>
    </div>


  </div>

  <div class="card" *ngIf="displayFPOTPVerify">
    <div class="logo-backBtn-container">
      <div class="back-btn-container">
        <div (click)="navVerifyOTPBackBtn()" class="back-button">
          <img class="back-arrow-icon" src="../../../../assets//back-arrow.svg" alt="navigate back" />
        </div>
      </div>
    </div>

    <div class="title-container">

      <h1 class="title-2">Two Factor Authentication Pending</h1>
    </div>
    <div class="text-container">
      <p class="text-1">A WhatsApp has been sent to you with an OTP.</p>

      <p class="text-3">Please submit to continue.</p>
    </div>

    <div class="otp-input-container">
      <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="otpConfig" #ngOtpInput></ng-otp-input>
    </div>

    <div *ngIf="otpTimer > 0; else showOtpResendButton" class="otp-countdown-txt-container">
      <p>Resend OTP in {{ countDownTimer$ | async }} seconds.</p>
    </div>

    <ng-template #showOtpResendButton>
      <div class="resent-otp-mobile-btn">
        <button (click)="resendOtp(true)" class="resend-btn">Resend OTP to Mobile</button>
        <div *ngIf="hasEmailAddress">
          <button (click)="resendOtp(false)" class="resend-btn">Resend OTP to Email</button>
        </div>
      </div>
    </ng-template>
  </div>

  <div class="card" *ngIf="displayFPConfirmPasscode">
    <div class="logo-backBtn-container">
      <div class="back-btn-container">
        <div (click)="navConfirmPasscodeBackBtn()" class="back-button">
          <img class="back-arrow-icon" src="../../../../assets//back-arrow.svg" alt="navigate back" />
        </div>
      </div>
    </div>

    <div class="title-container">
      <h1 class="title-2">Create a New Passcode</h1>
    </div>


    <div class="text-container">
      <p class="text-1">Enter your new passcode.</p>

    </div>

    <div class="input-box">
      <form [formGroup]="fpConfirmPasscodeForm">
        <div class="input-container">
          <input
                maxlength="4"
                formControlName="passcode"
                id="passcode"
                class="passcode"
                type="password"
                placeholder="Passcode"
                (keyup.enter)="signIn()"
              />
          <div class="p-field">

              <input
                maxlength="4"
                formControlName="confirmpasscode"
                id="confirmpasscode"
                class="passcode"
                type="password"
                placeholder="Confirm Passcode"
                (keyup.enter)="signIn()"
              />


          </div>
        </div>
      </form>
    </div>

    <div class="signinbutton">
      <dx-button type="default" mode="contained" [disabled]="fpConfirmPasscodeForm.invalid" (click)="onConfirmPasscodeClick()" class="sign-in-button">Submit</dx-button>
    </div>


  </div>
</div>
